module.exports = "a:hover \n{ \n    cursor: pointer;\n    text-decoration: underline;\n}\n\na\n{\n    color: blue;\n}\n\na:visited\n{\n    color: blue;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/search-docusign/search-docusign.css
// module id = ./src/app/components/search-docusign/search-docusign.css
// module chunks = main